import React, {useState} from 'react'
import classnames from "classnames";
import _ from 'lodash'

import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import Box from "@mui/material/Box";
import {useDealContext} from "../../contexts/DealContext";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import TableHead from "@mui/material/TableHead";
import Collapse from "@mui/material/Collapse";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import {NumericFormat} from "react-number-format";
import {DealPageTaxItem} from "./DealPageTaxItem";
import Checkbox from "@mui/material/Checkbox";
import Tooltip from "@mui/material/Tooltip";


export const DealPageTaxes = () => {
    const { setDealStateWithUpdate, updateDealResponse, dealState } = useDealContext()
    const [open, setOpen] = useState(false);

    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })

    if (!(dealState && dealState?.formatted_quote)) return null;

    const isLoading = updateDealResponse?.isLoading


    const tooltip = dealState.is_tax_exempt ? "Check to apply taxes" : "Uncheck for tax exempt"

    const taxes = dealState.formatted_quote.taxes.filter(t => t.amount !== '0')

    const totalTaxesAmount = taxes.reduce(function(accumulator, tax) {
        return accumulator + Number(tax.amount);
    }, 0)

    return (
        <Box className={classnames("dealPageFees", {
            mobile: isTabletOrMobile
        })}>
            <Stack
                direction={'row'}
                justifyContent="space-between"
                alignItems="center"
                className={'header header-row'}
            >
                <div
                    className={'header-name'}
                >
                        Taxes
                    <Tooltip title={tooltip} arrow placement={'top'}>
                        <Checkbox
                                className={classnames('payment-row_value taxes-checkbox', {
                                    isPurchase: dealState.is_purchase
                                })}
                                onChange={() => setDealStateWithUpdate({...dealState, is_tax_exempt: !dealState.is_tax_exempt}, true)}
                                checked={!dealState.is_tax_exempt}
                                disabled={isLoading}
                            />
                    </Tooltip>
                </div>
                <Stack
                    direction={'row'}
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <div className={'header-amount'}>
                        <NumericFormat
                            value={_.round(totalTaxesAmount, 2)}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                        />
                    </div>
                    <div>
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => setOpen(!open)}
                        >
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </div>
                </Stack>
            </Stack>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell
                                className={'header-cell'}
                                align="left"
                                width={isTabletOrMobile ? '30%' : '40%'}
                            >
                                Name
                            </TableCell>
                            {
                                !isTabletOrMobile &&
                                <TableCell
                                    className={'header-cell'}
                                    align="right"
                                    width={'25%'}
                                >
                                    Taxable Amount
                                </TableCell>
                            }
                            <TableCell
                                className={'header-cell'}
                                align="right"
                                width={'10%'}
                            >
                                Capped
                            </TableCell>
                            <TableCell
                                className={'header-cell'}
                                align="right"
                                width={isTabletOrMobile ? '40%' : '25%'}
                            >
                                Tax
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {/*<DealPageMonthlyTaxItem/>*/}
                        {
                            taxes.map((tax, idx) => {
                                return (
                                    <DealPageTaxItem
                                        key={tax.name}
                                        taxItem={tax}
                                    />
                                )
                            })
                        }
                    </TableBody>
                </Table>
            </Collapse>
        </Box>
    )
}